import React, { memo } from "react";
import { classNames } from "helpers";
import { ReactSVG } from "react-svg";

interface OfficeStepStatusBarProps {
  stepLabels: string[];
  stepCurrent: number;
  onStepClick?: (stepIndex: number) => void;
  firstStepCompleted?: boolean;
}

const OfficeStepStatusBar: React.FC<OfficeStepStatusBarProps> = ({
  stepLabels,
  stepCurrent,
  onStepClick,
  firstStepCompleted = false,
}) => {
  return (
    <div className="w-50 flex border border-x-0 border-t-0 border-slate-200 overflow-hidden  ">
      {stepLabels.map((label, index) => {
        const isActive = index === stepCurrent;
        const isPast = index < stepCurrent;
        const isFirstStep = index === 0;
        // Naprijed se ide samo kroz "Nastavi" (koji validira trenutni korak) —
        // klik na korak ispred trenutnog je onemogućen da se ne preskoči
        // validacija. Natrag na već prođene korake je dozvoljeno.
        const isDisabled =
          isFirstStep ||
          (!firstStepCompleted && index > 0) ||
          index > stepCurrent;

        // Prvi korak je "u tijeku" (svijetlo plavo, bez kvačice) dok se radi
        // unos i još nije uspješno spremljen. Čim se pređe na drugi korak — ili
        // u editu, gdje je od početka spremljen — postaje gotov: svijetlo zeleno
        // s kvačicom.
        const isCompleted =
          isPast || (isActive && isFirstStep && firstStepCompleted);
        const isInProgress = isActive && !isCompleted;

        return (
          <button
            key={index}
            type="button"
            disabled={isDisabled}
            onClick={() => !isDisabled && onStepClick?.(index)}
            className={classNames(
              "flex-1 flex items-center justify-center gap-2 py-2.5 px-3 text-sm border-r last:border-r-0 transition-all duration-200",
              isCompleted
                ? "bg-green-100 text-green-800 font-semibold border-b-2 border-b-green-600"
                : isInProgress
                  ? "bg-sky-50 text-sky-700 font-medium border-slate-200"
                  : "bg-white text-slate-400 font-medium border-slate-200",
              !isDisabled && "cursor-pointer hover:opacity-80"
            )}
          >
            {isCompleted && (
              <ReactSVG
                src="/media/icons/check.svg"
                className="w-4 h-4 stroke-green-700"
              />
            )}
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default memo(OfficeStepStatusBar);
